import { MusicNoteIcon } from "@heroicons/react/outline";

export default function UpgradeTableModal({ eventId, onYes, onNo }) {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-end sm:items-center justify-center px-4 pb-6 sm:pb-0">
      <div className="w-full max-w-sm bg-[#02160e] border border-green-900/40 rounded-2xl p-6 space-y-5 shadow-2xl">

        {/* ICON */}
        <div className="w-14 h-14 mx-auto rounded-full bg-green-500/10 border border-green-500/20 flex items-center justify-center">
          <MusicNoteIcon className="w-4 h-4 text-slate-400 "/>
        </div>

        {/* TEXT */}
        <div className="text-center">
          <h2 className="text-lg font-bold text-white mb-2">
            ¿Te gustaría mejorar a una mesa?
          </h2>
          <p className="text-sm text-gray-400 leading-relaxed">
            Puedes reservar una mesa VIP en lugar de entradas estándar y disfrutar de una experiencia premium.
          </p>
        </div>

        {/* BUTTONS */}
        <div className="flex flex-col gap-3">
          <button
            onClick={onYes}
            className="w-full py-3 rounded-xl bg-green-500 text-black font-bold tracking-widest uppercase text-sm hover:bg-green-400 transition"
          >
            Sí, ver mesas →
          </button>
          <button
            onClick={onNo}
            className="w-full py-3 rounded-xl border border-green-900/40 text-gray-400 text-sm tracking-widest uppercase hover:border-green-700/50 hover:text-white transition"
          >
            No, continuar con entradas
          </button>
        </div>

      </div>
    </div>
  );
}